import React from 'react';
import { Skeleton } from '@mui/material';
import { useSubjectInfo } from '../../features/subject/hooks/useSubjectUsers';

interface SubjectNameDisplayProps {
  tenantId: string;
  subjectId: string;
  fallback?: string;
  showSkeleton?: boolean;
}

/**
 * Component that displays a subject's name by fetching it from their ID
 * Shows a loading skeleton while fetching and fallback text for errors
 * Requires tenantId for tRPC key lookup
 */
export const SubjectNameDisplay: React.FC<SubjectNameDisplayProps> = ({
  tenantId,
  subjectId,
  fallback = 'Unknown Subject',
  showSkeleton = true,
}) => {
  const { data: subject, isLoading, isError } = useSubjectInfo(tenantId, subjectId);

  if (!subjectId) {
    return <span>{fallback}</span>;
  }

  if (isLoading && showSkeleton) {
    return <Skeleton variant="text" width={120} height={20} />;
  }

  if (isError || !subject) {
    return <span>{fallback}</span>;
  }

  return <span>{subject.name || subject.code || fallback}</span>;
};

export default SubjectNameDisplay;
